import { createSlice, PayloadAction } from "@reduxjs/toolkit"

/**
 * Auth slice - Minimal auth state
 *
 * Note: Authentication is handled by Clerk (single source of truth)
 * This slice stores organizationId for WebSocket room joining
 * and user profile info for presence features
 */
export interface AuthState {
  organizationId: string | null
  userName: string | null
  avatarUrl: string | null
}

const initialState: AuthState = {
  organizationId: null,
  userName: null,
  avatarUrl: null
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setOrganizationId(state, action: PayloadAction<string | null>) {
      state.organizationId = action.payload
    },
    setUserInfo(
      state,
      action: PayloadAction<{ userName?: string | null; avatarUrl?: string | null }>
    ) {
      if (action.payload.userName !== undefined) {
        state.userName = action.payload.userName ?? null
      }
      if (action.payload.avatarUrl !== undefined) {
        state.avatarUrl = action.payload.avatarUrl ?? null
      }
    }
  }
})

export const { setOrganizationId, setUserInfo } = authSlice.actions
export default authSlice.reducer
